import React, { useState } from 'react'
import {
  Container,
  CardGroup,
  Card,
  CardContent,
  CardHeader,
  CardDescription,
  CardMeta,
  Rating,
  Button
} from 'semantic-ui-react'
import G from './G'
import { getReviews } from '../services/reviews-list'

const defaultReviewCount = 6
export default function ShowReviews({
  title = ' Hear From Your neighbors',
  reviewCount = defaultReviewCount,
  showControls = true,
  showCount,
  style,
  backgroundColor = 'green',
  cardColor = ''
}) {
  // const reviews = getReviews(reviewCount)
  const [state, setState] = useState({
    startCount: 0,
    reviews: getReviews(reviewCount)
  })

  showCount = showCount
    ? showCount
    : window.innerWidth <= 643
      ? 1
      : window.innerWidth <= 992
        ? 2
        : 3

  const { reviews, startCount } = state
  const items = []
  for (let i = startCount; i < showCount + startCount; i++) {
    const review = reviews[i]
    items.push(
      <Card key={i}>
        <CardContent>
          <CardHeader
            content={review.name}
            style={{ fontSize: '1.2em', marginBottom: '7px' }}
          />
          <CardMeta
            content={
              <>
                <Rating icon="star" defaultRating={5} maxRating={5} disabled />
                <G />
              </>
            }
          />
          <CardDescription content={review.content} />
        </CardContent>
      </Card>
    )
  }

  const changeView = (count) => {
    const newCount = state.startCount + count
    if (0 <= newCount && newCount + showCount <= reviews.length) {
      setState({ ...state, startCount: newCount })
    }
  }

  return (
    <div
      className={`reviews-area${backgroundColor ? ` ${backgroundColor}-background` : ''}${cardColor ? ` ${cardColor}-card-background` : ''}`}
      style={style}>
      <Container>
        <h2 className="reviews-title">
          {title}
          {showControls ? (
            <>
              <div style={{ display: 'inline-block', marginLeft: '25px' }}>
                <Button
                  className="prev"
                  onClick={() => changeView(-1)}
                  icon="arrow left"
                  disabled={startCount === 0}
                />
                <Button
                  className="prev"
                  onClick={() => changeView(1)}
                  icon="arrow right"
                  disabled={startCount + showCount === reviews.length}
                />
              </div>
            </>
          ) : (
            ''
          )}
        </h2>
        <CardGroup centered>{items}</CardGroup>
      </Container>
    </div>
  )
}
